require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./goog.object.object.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.js_interop.js_proxy.js");
goog.provide('com.wsscode.js_interop.js_proxy');

if (typeof com !== 'undefined' && typeof com.wsscode !== 'undefined' && typeof com.wsscode.js_interop !== 'undefined' && typeof com.wsscode.js_interop.js_proxy !== 'undefined' && typeof com.wsscode.js_interop.js_proxy.kw_cache !== 'undefined') {} else {
  com.wsscode.js_interop.js_proxy.kw_cache = {};
}
/**
 * Like keyword, but will cache the string for faster lookup after first usage.
 */


com.wsscode.js_interop.js_proxy.cached_keyword = function com$wsscode$js_interop$js_proxy$cached_keyword(s) {
  var or__4126__auto__ = com.wsscode.js_interop.js_proxy.kw_cache[s];

  if (cljs.core.truth_(or__4126__auto__)) {
    return or__4126__auto__;
  } else {
    var kw = cljs.core.keyword.cljs$core$IFn$_invoke$arity$1(s);
    goog.object.set(com.wsscode.js_interop.js_proxy.kw_cache, s, kw);
    return kw;
  }
};
/**
 * Wrapping on JS .push, arity design for compatibility with transducer usage.
 */


com.wsscode.js_interop.js_proxy.array_push = function com$wsscode$js_interop$js_proxy$array_push(var_args) {
  var G__24392 = arguments.length;

  switch (G__24392) {
    case 1:
      return com.wsscode.js_interop.js_proxy.array_push.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return com.wsscode.js_interop.js_proxy.array_push.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.js_interop.js_proxy.array_push.cljs$core$IFn$_invoke$arity$1 = function (res) {
  return res;
};

com.wsscode.js_interop.js_proxy.array_push.cljs$core$IFn$_invoke$arity$2 = function (res, x) {
  var G__24393 = res;
  G__24393.push(x);
  return G__24393;
};

com.wsscode.js_interop.js_proxy.array_push.cljs$lang$maxFixedArity = 2;
/**
 * Its the into-array fn with add support for transducers.
 */

com.wsscode.js_interop.js_proxy.into_js_array = function com$wsscode$js_interop$js_proxy$into_js_array(xform, from) {
  return cljs.core.transduce.cljs$core$IFn$_invoke$arity$4(xform, com.wsscode.js_interop.js_proxy.array_push, [], from);
};
/**
 * Proxy some Map Type from Clojurescript via JSON proxy API.
 */


com.wsscode.js_interop.js_proxy.js_proxy = function com$wsscode$js_interop$js_proxy$js_proxy(x) {
  if (cljs.core.sequential_QMARK_(x) || cljs.core.set_QMARK_(x)) {
    return com.wsscode.js_interop.js_proxy.into_js_array(cljs.core.map.cljs$core$IFn$_invoke$arity$1(com.wsscode.js_interop.js_proxy.js_proxy), x);
  } else {
    if (cljs.core.associative_QMARK_(x)) {
      return com.wsscode.js_interop.js_proxy.map_proxy.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.js_interop.js_proxy.map_proxy.cljs$core$IFn$_invoke$arity$1(x) : com.wsscode.js_interop.js_proxy.map_proxy.call(null, x);
    } else {
      return x;
    }
  }
};

com.wsscode.js_interop.js_proxy.map_proxy_get = function com$wsscode$js_interop$js_proxy$map_proxy_get(t, k) {
  var G__24394 = k;

  switch (G__24394) {
    case "__source-structure":
      return t;
      break;

    default:
      return com.wsscode.js_interop.js_proxy.js_proxy(cljs.core.get.cljs$core$IFn$_invoke$arity$2(t, com.wsscode.js_interop.js_proxy.cached_keyword(k)));
  }
};

com.wsscode.js_interop.js_proxy.map_proxy_own_keys = function com$wsscode$js_interop$js_proxy$map_proxy_own_keys(t, _, internal_cache) {
  var or__4126__auto__ = internal_cache["__keys"];

  if (cljs.core.truth_(or__4126__auto__)) {
    return or__4126__auto__;
  } else {
    var ks = com.wsscode.js_interop.js_proxy.into_js_array(cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (p1__24395_SHARP_) {
      return cljs.core.subs.cljs$core$IFn$_invoke$arity$2(cljs.core.pr_str.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([p1__24395_SHARP_], 0)), 1);
    }), cljs.core.keys(t));
    internal_cache["__keys"] = ks;
    return ks;
  }
};

com.wsscode.js_interop.js_proxy.map_proxy_has = function com$wsscode$js_interop$js_proxy$map_proxy_has(t, k) {
  return cljs.core.contains_QMARK_(t, com.wsscode.js_interop.js_proxy.cached_keyword(k));
};

com.wsscode.js_interop.js_proxy.map_proxy_property_descriptor = function com$wsscode$js_interop$js_proxy$map_proxy_property_descriptor(t, k) {
  var temp__5802__auto__ = cljs.core.find(t, cljs.core.keyword.cljs$core$IFn$_invoke$arity$1(k));

  if (cljs.core.truth_(temp__5802__auto__)) {
    var x = temp__5802__auto__;
    return {
      "value": cljs.core.val(x),
      "writable": true,
      "enumerable": true,
      "configurable": true
    };
  } else {
    return undefined;
  }
};
/**
 * Creates a JS proxy to wrap a Clojurescript immutable map like data type.
 */


com.wsscode.js_interop.js_proxy.map_proxy = function com$wsscode$js_interop$js_proxy$map_proxy(m) {
  var internal_cache = {};
  return new Proxy(m, {
    "get": com.wsscode.js_interop.js_proxy.map_proxy_get,
    "ownKeys": function ownKeys(p1__24396_SHARP_, p2__24397_SHARP_) {
      return com.wsscode.js_interop.js_proxy.map_proxy_own_keys(p1__24396_SHARP_, p2__24397_SHARP_, internal_cache);
    },
    "has": com.wsscode.js_interop.js_proxy.map_proxy_has,
    "getOwnPropertyDescriptor": com.wsscode.js_interop.js_proxy.map_proxy_property_descriptor
  });
};
/**
 * Shorter name for js-proxy.
 */


com.wsscode.js_interop.js_proxy.jsp = function com$wsscode$js_interop$js_proxy$jsp(x) {
  return com.wsscode.js_interop.js_proxy.js_proxy(x);
};

Object.defineProperty(module.exports, "map_proxy_has", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.map_proxy_has;
  }
});
Object.defineProperty(module.exports, "map_proxy", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.map_proxy;
  }
});
Object.defineProperty(module.exports, "cached_keyword", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.cached_keyword;
  }
});
Object.defineProperty(module.exports, "js_proxy", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.js_proxy;
  }
});
Object.defineProperty(module.exports, "map_proxy_get", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.map_proxy_get;
  }
});
Object.defineProperty(module.exports, "map_proxy_own_keys", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.map_proxy_own_keys;
  }
});
Object.defineProperty(module.exports, "array_push", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.array_push;
  }
});
Object.defineProperty(module.exports, "kw_cache", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.kw_cache;
  }
});
Object.defineProperty(module.exports, "jsp", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.jsp;
  }
});
Object.defineProperty(module.exports, "into_js_array", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.into_js_array;
  }
});
Object.defineProperty(module.exports, "map_proxy_property_descriptor", {
  enumerable: false,
  get: function get() {
    return com.wsscode.js_interop.js_proxy.map_proxy_property_descriptor;
  }
});